import { PolicyType } from '@zorro/clients';
import { useRoles } from '@zorro/web/ui-utils';
import { $enum } from 'ts-enum-util';

import { PlanBadge } from '../PlanBadge';

const getPolicyTypeBadgeConfig = (
  policyType: PolicyType | null | undefined,
  isEmployeeOnlyRole: boolean
) => {
  return $enum.mapValue(policyType).with({
    [PolicyType.MEDICARE]: {
      label: 'Medicare',
      tooltipLabel: isEmployeeOnlyRole
        ? 'A Medicare plan, for household members eligible for Medicare'
        : 'Medicare plan — covers a household member eligible for Medicare',
    },
    [PolicyType.MEDICARE_IFP]: {
      label: 'Medicare + IFP',
      tooltipLabel: isEmployeeOnlyRole
        ? 'Your coverage combines a Medicare plan and an individual/family plan for different household members'
        : 'Coverage combines Medicare and individual/family plans for different household members',
    },
    [PolicyType.IFP]: {
      label: 'IFP',
      tooltipLabel: isEmployeeOnlyRole
        ? 'An individual/family market plan (non-Medicare)'
        : 'Individual/family market plan (non-Medicare)',
    },
    [$enum.handleUnexpected]: undefined,
    [$enum.handleUndefined]: undefined,
    [$enum.handleNull]: undefined,
  });
};

type Props = {
  policyType?: PolicyType | null;
};

export const PolicyTypeBadge = ({ policyType }: Props) => {
  const { isEmployeeOnlyRole } = useRoles();
  const badgeConfig = getPolicyTypeBadgeConfig(policyType, isEmployeeOnlyRole);
  if (!badgeConfig) {
    return null;
  }

  return (
    <PlanBadge
      tooltipLabel={badgeConfig.tooltipLabel}
      label={badgeConfig.label}
      size="sm"
    />
  );
};
